import Http from '@/classes/http/Http'
import Transform from '@/classes/form/Transform'

export default {
  getCases (filter = '') {
    return Http.get({
      url: `cases${filter}`
    })
  },
  getCase (caseId) {
    return Http.get({
      url: `cases/${caseId}`
    })
  },
  getCaseForReview (caseId) {
    return Http.get({
      url: `cases/review/${caseId}`
    })
  },
  patchCase (caseId, payload) {
    return Http.patch({
      url: `cases/${caseId}`,
      data: payload
    })
  },
  claimCase (caseId) {
    return Http.post({
      url: `cases/${caseId}/claim`
    })
  },
  clearResponsible (caseId) {
    return Http.patch({
      url: `cases/${caseId}/clear-responsible`
    })
  },
  setLegacyInvoiced (caseId) {
    return Http.patch({
      url: `cases/${caseId}/set-legacy-invoiced`
    })
  },
  revertCaseToReviewer (caseId) {
    return Http.patch({
      url: `cases/${caseId}/revert-case-to-reviewer`
    })
  },
  // handles rejection of cases
  getCaseCloseForm (caseId) {
    return Http.get({
      url: `cases/${caseId}/decline`
    })
  },
  postCaseCloseForm (caseId, data) {
    return Http.post({
      url: `cases/${caseId}/decline`,
      data: data
    })
  },
  // handles recommending of cases for rejection
  getRecommendCaseCloseForm (caseId) {
    return Http.get({
      url: `cases/${caseId}/recommendations/form`
    })
  },
  postRecommendCaseForm (caseId, data, recommendationType) {
    data.recommendation_type = recommendationType
    return Http.post({
      url: `cases/${caseId}/recommendations/form`,
      data: data
    })
  },
  getRecommendationComment (caseId) {
    return Http.get({
      url: `cases/${caseId}/recommendations`
    })
  },
  // handles approving of cases
  postCaseApproveForm (caseId, data) {
    return Http.post({
      url: `cases/${caseId}/approve`,
      data: data
    })
  },
  // handles review results
  getReviewResults (caseId) {
    return Http.get({
      url: `cases/${caseId}/review-results`
    })
  },
  patchReviewResult (reviewResult, formData) {
    return Http.patch({
      url: `cases/review-results/${reviewResult.id}`,
      data: Transform.createMultipartFormData(formData)
    })
  },
  patchReviewResultState (reviewResult, payload) {
    return Http.patch({
      url: `cases/review-results/${reviewResult.id}`,
      data: payload
    })
  },
  patchReviewResultsState (caseId, payload) {
    return Http.patch({
      url: `cases/${caseId}/review-results/states`,
      data: payload
    })
  },
  // handles findings for review results
  postFinding (reviewResultId, finding) {
    return Http.post({
      url: `cases/review-results/${reviewResultId}/findings`,
      data: finding
    })
  },
  patchFinding (finding) {
    return Http.patch({
      url: `cases/review-results/findings/${finding.id}`,
      data: finding
    })
  },
  postFindingComment (findingId, comment) {
    return Http.post({
      url: `cases/review-results/findings/${findingId}/comments`,
      data: comment
    })
  },
  // retrieves cases per profile type
  getAdministratorCases (administratorId, filter) {
    return Http.get({
      url: `${administratorId}/cases${filter}`
    })
  },
  getCustomerRespondedCases (profileId, filter) {
    return Http.get({
      url: `${profileId}/cases-customer-responded${filter}`
    })
  },
  getAuditorCases (auditorId, filter) {
    return Http.get({
      url: `${auditorId}/cases${filter}`
    })
  },
  getAuditorRequests (auditorId, filter) {
    return Http.get({
      url: `${auditorId}/cases/requests${filter}`
    })
  },
  postAuditorRequest (caseId, auditorId) {
    return Http.post({
      url: 'cases/requests',
      data: {
        case: caseId,
        auditor: auditorId
      }
    })
  },
  patchAuditorRequest (requestId, state) {
    return Http.patch({
      url: `cases/requests/${requestId}`,
      data: { state: state }
    })
  },
  setCaseController (caseId) {
    return Http.post({
      url: `cases/${caseId}/controller/claim`
    })
  },
  setCaseNotInvoiceable (caseId) {
    return Http.patch({
      url: `cases/${caseId}/not-invoiceable`
    })
  },
  setCaseInvoiceable (caseId) {
    return Http.patch({
      url: `cases/${caseId}/invoiceable`
    })
  }
}
